
define('text!libs/strand/src/shared/js/eventdispatcher.html',[],function () { return '<script src="../../../bower_components/eventdispatcherjs/src/EventDispatcher.js">\n</script>';});

